import { render } from "./OrganizationDashboard.vue?vue&type=template&id=3cf951fd"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__